module.exports = __webpack_public_path__ + "static/media/Aurella-01.001860ca.svg";